<template>
  <article class="article page">
    <header>
      <slot name="top-title"></slot>
      <h1 v-html="postTitle"></h1>
      <slot name="bottom-title"></slot>
    </header>
    <main class="content" ref="articleContent"
      v-html="postContent"
      >
    </main>
    <slot name="bottom-content"></slot>
  </article>
</template>

<script>

import PageData from '@/mixins/PageData'
import CommonMethods from '@/mixins/CommonMethods'

export default {
  
  mixins:[PageData,CommonMethods],
  props: {
    name: String
  },
  data:()=>({
    data:null,
    postTitle:"",
    postContent:"",
    active:false
    
  }),
  mounted(){

    this.pageLoading()


    // this.$Lazyload.$on('error', function ({  el, src,error }) {
    //   console.log(el, src, error)
    //   el.setAttribute('src', el.getAttribute('data-full-url'))
    // })

    this.getPage(this.name)
    .then(data =>{
        this.data = data;
        this.postTitle = data.title.rendered;
        this.postContent = data.content.rendered;

        this.$nextTick(()=>{
          this.articleContentFunc(this.$refs.articleContent);
          this.pageLoaded()
        })


        this.active = true;
    })
  }
}
</script>